import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import moment from "moment";

class TravelRequestsPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Travel request",
      state: "travelrequest",
      name: "travelrequest",
    };
    this.filters = [
      {
        name: "travel_date",
        title: "Travel date",
        hasRange: false,
        icon: "date_range",
        isDate: true,
      },
      {
        name: "resolved",
        title: "Resolved",
        icon: "check_circle_outline",
        list: "resolvedTravelRequest",
      },
      {
        name: "from",
        title: "From",
        icon: "trip_origin",
        list: "fromTravelCities",
      },
      {
        name: "to",
        title: "To",
        icon: "fiber_manual_record",
        list: "toTravelCities",
      },
    ];

    this.fields = [
      { title: "Travel Date", name: "travel_date" },
      { title: "From", name: "from" },
      { title: "To", name: "to" },
    ];
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const formatDate = (item) => {
      item.travel_date = moment(item.travel_date).format(constants.dateFormat);

      return item;
    };

    return map(flow([getSource, formatDate]))(data);
  }
}

export default TravelRequestsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/travelRequests/travelRequests.transforms.js